import React, { useEffect, useState } from "react";
import { CheckCircle2, Circle } from "lucide-react";
import { api } from "../../lib/api";

export default function ClientTasks() {
  const [tasks, setTasks] = useState([]);
  const load = () => api.get("/client/tasks").then(({ data }) => setTasks(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (t) => {
    await api.put(`/tasks/${t.id}/status`, { status: t.status === "termine" ? "a_faire" : "termine" });
    load();
  };

  const todo = tasks.filter((t) => t.status !== "termine");
  const done = tasks.filter((t) => t.status === "termine");

  return (
    <div className="max-w-2xl space-y-8">
      <div>
        <p className="eyebrow">Ton plan d'action</p>
        <h1 className="mt-2 font-sans font-medium text-4xl text-ink sm:text-5xl">Mes tâches</h1>
        <p className="mt-2 text-ink-soft">Les actions que Fanny t'a confiées. Coche-les au fur et à mesure.</p>
      </div>

      <section>
        <h2 className="mb-3 font-sans font-medium text-xl text-ink">À faire ({todo.length})</h2>
        <div className="space-y-2">
          {todo.map((t) => (
            <div key={t.id} data-testid={`task-${t.id}`} className="flex items-center gap-3 rounded-xl border border-line bg-white p-4 shadow-card">
              <button data-testid={`task-toggle-${t.id}`} onClick={() => toggle(t)} className="text-bordeaux"><Circle size={20} className="text-ink-muted" /></button>
              <span className="text-sm text-ink">{t.title}</span>
            </div>
          ))}
          {todo.length === 0 && <p className="text-ink-muted">Rien à faire pour l'instant ✨</p>}
        </div>
      </section>

      {done.length > 0 && (
        <section>
          <h2 className="mb-3 font-sans font-medium text-xl text-ink">Terminées ({done.length})</h2>
          <div className="space-y-2">
            {done.map((t) => (
              <div key={t.id} className="flex items-center gap-3 rounded-xl border border-line bg-cream/60 p-4">
                <button onClick={() => toggle(t)} className="text-[#059669]"><CheckCircle2 size={20} /></button>
                <span className="text-sm text-ink-muted line-through">{t.title}</span>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
